import { BotVoiceType, CallDifficultyMode, BotLanguage } from './db'

export interface InterviewPortalInfo {
  portal_id: string
  team_id: string
  creator_user_id: string
  name: string
  description: string | null
  password: string
  bot_ids: string[]
  max_calls_per_user: number | null
  difficulty_level: CallDifficultyMode | null
  language: BotLanguage | null
  resource_urls: string[] | null
  created_at: string
  updated_at: string
}

export interface InterviewBotCall {
  bot_call_id: string
  portal_id: string
  user_email: string
  bot_id: string
  vapi_bot_call_id?: string | null
  transcript?: string | null
  recording_url?: string | null
  call_duration_seconds?: number | null
  created_at: string
  ended_at?: string | null
}

export interface InterviewBot {
  bot_id: string
  team_id: string
  name: string
  description?: string | null
  meta_description?: string | null
  voice: BotVoiceType
  user_id: string
  created_at: string
  updated_at: string
}

export interface CreateInterviewBotCallRequest {
  portal_id: string
  user_email: string
  password: string
  bot_id: string
}

export interface CreateInterviewBotCallResponse {
  bot_call_id: string
  vapi_call_url?: string | null
}


export interface InterviewPortalUser {
  portal_id: string
  user_email: string
  first_call_at: string
  last_call_at: string
  total_calls: number
}

export interface CreateInterviewPortalRequest {
  name: string
  description?: string | null
  password: string
  bot_ids: string[]
  max_calls_per_user?: number | null
  difficulty_level?: CallDifficultyMode | null
  language?: BotLanguage | null
  resource_urls?: string | null
}

export interface UpdateInterviewPortalRequest {
  name?: string
  description?: string | null
  password?: string
  bot_ids?: string[]
  max_calls_per_user?: number | null
  difficulty_level?: CallDifficultyMode | null
  language?: BotLanguage | null
  resource_urls?: string | null
}

// JSON conversion functions
export function jsonSafeToInterviewPortalInfo(data: any): InterviewPortalInfo {
  return {
    portal_id: data.portal_id,
    team_id: data.team_id,
    creator_user_id: data.creator_user_id,
    name: data.name,
    description: data.description,
    password: data.password,
    bot_ids: data.interview_bot_ids ? data.interview_bot_ids.split(',').filter(Boolean) : [],
    max_calls_per_user: data.max_calls_per_user,
    difficulty_level: data.difficulty_level,
    language: data.language,
    resource_urls: data.resource_urls ? data.resource_urls.split(',').filter(Boolean) : null,
    created_at: data.created_at,
    updated_at: data.updated_at
  }
}

export function jsonSafeToInterviewBotCall(data: any): InterviewBotCall {
  return {
    bot_call_id: data.bot_call_id,
    portal_id: data.portal_id,
    user_email: data.user_email,
    bot_id: data.bot_id,
    vapi_bot_call_id: data.vapi_bot_call_id,
    transcript: data.transcript,
    recording_url: data.recording_url,
    call_duration_seconds: data.call_duration_seconds,
    created_at: data.created_at,
    ended_at: data.ended_at
  }
}

export function jsonSafeToInterviewPortalUser(data: any): InterviewPortalUser {
  return {
    portal_id: data.portal_id,
    user_email: data.user_email,
    first_call_at: data.first_call_at,
    last_call_at: data.last_call_at,
    total_calls: data.total_calls
  }
}

export function jsonSafeToInterviewBot(data: any): InterviewBot {
  return {
    bot_id: data.bot_id,
    team_id: data.team_id,
    name: data.name,
    description: data.description,
    meta_description: data.meta_description,
    voice: data.voice,
    user_id: data.user_id,
    created_at: data.created_at,
    updated_at: data.updated_at
  }
}

export function jsonSafeToInterviewBots(data: any): InterviewBot[] {
  if (!Array.isArray(data)) return []
  return data.map(jsonSafeToInterviewBot)
}

export function jsonSafeToInterviewBotCalls(data: any): InterviewBotCall[] {
  if (!Array.isArray(data)) return []
  return data.map(jsonSafeToInterviewBotCall)
}